import React from 'react';

import Link from 'buyside/components/presentation/Link/link';

import { employerProfileDocumentUrl } from 'buyside/util/urlHelper';
import { ActivityFeedEmployerProfileUpdateFragment } from 'interfaces/graphql-typings';

import styles from './fundUpdateMarketingMaterialsStyles.scss';

const FundUpdateMarketingMaterials: React.FC<{
  marketingMaterials: ActivityFeedEmployerProfileUpdateFragment['marketingMaterials'];
}> = ({ marketingMaterials }) => {
  if (!marketingMaterials || !marketingMaterials.edges) {
    return null;
  }

  return (
    <div className={styles.fundUpdateMarketingMaterials}>
      <div className={styles.table}>
        <div className={styles.tableRow}>
          <span className={styles.th}>Document</span>
          <span className={styles.th}>Type</span>
        </div>

        {marketingMaterials.edges.map((edge, idx) => {
          const marketingMaterial = edge?.node;

          return (
            <div className={styles.tableRow} key={idx}>
              <span className={styles.td}>
                {marketingMaterial?.id && (
                  <Link to={employerProfileDocumentUrl(marketingMaterial?.id)}>
                    {marketingMaterial?.name}
                  </Link>
                )}
              </span>
              <span className={styles.td}>{marketingMaterial?.category}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FundUpdateMarketingMaterials;
